import { CommonModule, isPlatformBrowser } from '@angular/common';
import { AfterViewInit, Component, Inject, Input, OnDestroy, OnInit, PLATFORM_ID, SimpleChanges } from '@angular/core';
import { DashboardV2ProjectListComponent } from './dashboard-v2-project-list/dashboard-v2-project-list.component';
import { DashboardV2QuickActionsComponent } from './dashboard-v2-quick-actions/dashboard-v2-quick-actions.component';
import { DashboardV2SummaryCardsComponent } from './dashboard-v2-summary-cards/dashboard-v2-summary-cards.component';
import { DashboardV2BannerComponent } from './dashboard-v2-banner/dashboard-v2-banner.component';
import { DashboardV2SubmenuComponent } from "./dashboard-v2-submenu/dashboard-v2-submenu.component";
import { DevelopmentService, UserService } from '@app/services';
import { DashboardV2SlidesComponent } from "../dashboard-v2-slides/dashboard-v2-slides.component";
import { debounceTime, fromEvent, Subject, takeUntil, timer } from 'rxjs';
import { User } from '@app/models';

declare var cordova: any;
@Component({
  selector: 'mnf-dashboard-v2-investors',
  standalone: true,
  imports: [
    CommonModule,
    DashboardV2ProjectListComponent,
    DashboardV2QuickActionsComponent,
    DashboardV2SummaryCardsComponent,
    DashboardV2BannerComponent,
    DashboardV2SubmenuComponent,
    DashboardV2SlidesComponent
],
  templateUrl: './dashboard-v2-investors.component.html',
  styleUrl: './dashboard-v2-investors.component.scss'
})
export class DashboardV2InvestorsComponent implements OnInit, AfterViewInit, OnDestroy{

  @Input() user: User;
  
  @Input() step!: number;
  @Input() status!: { 
    isLead: boolean; 
    isInvestor: boolean; 
    isNotInvestor: boolean; 
    isFullGrowthLead: boolean; 
    isFullDomLead: boolean; 
    isFullLead: boolean; 
  };

  isBrowser: boolean;
  containerWidth: boolean;
  userWithDomiciliation: boolean = false;
  userWithAutoGrowth: boolean = false;
  userWithBothStatus: boolean = false;
  private readonly destroy$ = new Subject<void>();

  developmentsAvailable: any[] = [];

  profitUser: {  beneficio_no_referred: number, beneficio_referred: number, rendimientos: number }
  
  platformType: 'ios' | 'android' | 'web' = 'web';
  isNativePlatform: boolean = false;

  constructor(private userServ: UserService, @Inject(PLATFORM_ID) private platformId: Object, private devServ: DevelopmentService) { 
    this.isBrowser = isPlatformBrowser(this.platformId);
    this.platformType = typeof cordova !== 'undefined' ? 'ios' : 'web';
  }

  ngOnInit(){
    this.isNativePlatform = this.platformType === 'ios' || this.platformType === 'android';
    
    this.userServ.getProfitDashboard().pipe(
      takeUntil(this.destroy$)
    ).subscribe(res => {
      this.profitUser = res;
    })
    
    if(this.isBrowser){
      //Funciones para detectar el tamaño de la pantalla
      this.checkScreenSize();
      this.setupResizeListener();
      this.getAllDevelopments();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes['user']) {
      this.user = changes['user'].currentValue;
      this.userWithDomiciliation = this.user?.domiciliation?.status === 'ACTIVE';
      this.userWithAutoGrowth = this?.user?.autoinvest?.status === 'ACTIVE';
    }
  }

  ngAfterViewInit(){
    timer(700).pipe(
      takeUntil(this.destroy$)
    ).subscribe(() => {
        this.userWithBothStatus = this.userWithDomiciliation && this.userWithAutoGrowth;
      })
  }

  checkScreenSize(){
    if(!this.isBrowser) return;
    const isLargeScreen = window.innerWidth >= 992;
    this.containerWidth = isLargeScreen;
  }


  private setupResizeListener(){
    fromEvent(window, 'resize')
    .pipe(
      debounceTime(200),
      takeUntil(this.destroy$)
    )
    .subscribe(() => { this.checkScreenSize(); } )
  }

  private getAllDevelopments() {
    return this.devServ.getAllDevelopments().pipe(
      takeUntil(this.destroy$)
    ).subscribe((devs: any[]) => {
      this.developmentsAvailable = devs;
    })
  }

  ngOnDestroy(){
    this.destroy$.next();
    this.destroy$.complete();
  }
}
